import { Text } from '@mentimeter/ragnar-ui/text';

export function WorkspaceName({ name }: { name: string | null | undefined }) {
  if (name) return <Text fontWeight="semiBold">{name}</Text>;
  else return <>your workspace</>;
}
